import { Button } from "./tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "./tailwind/dialog";

const AutoreplyConflictModal = ({
  isOpen,
  onClose,
  onConfirm,
  activeChatbot,
  newChatbotName,
  isConfirming,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        if (!isConfirming) {
          onClose();
        }
      }}
    >
      <DialogTitle close={!isConfirming}>
        Another autoreply chatbot is already active
      </DialogTitle>
      <DialogBody>
        <p>
          The chatbot <b>{activeChatbot?.name}</b> is currently set as the autoreply chatbot.
        </p>
        <p className="mt-2">
          Activating <b>{newChatbotName}</b> will deactivate <b>{activeChatbot?.name}</b>.
        </p>
        <p className="mt-2">Do you want to continue?</p>
      </DialogBody>
      <DialogActions>
        <Button
          color="secondaryButton"
          onClick={onClose}
          disabled={isConfirming}
        >
          Cancel
        </Button>
        <Button color="primaryButton" onClick={onConfirm} loading={isConfirming}>
          Activate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutoreplyConflictModal;
